<script>
    import {LeafletMap, Marker, Popup, TileLayer} from 'svelte-leafletjs';
    import {onMount} from "svelte";
    import * as linkify from "linkifyjs";
    import linkifyHtml from "linkify-html";
    import Service from "../../utils/Service";

    export let config;
    export let cid;

    const service = new Service(config.model_root);

    let resourcesLoaded = 0;

    let map_items = [];
    let map_config = {};

    onMount(() => {
        loadMapElems().then(mapItems => {
            map_items = mapItems;
            resourcesLoaded++;
        })
        loadMapConfig().then(mapConfig => {
            map_config = mapConfig[0];
            console.log(map_config)
            resourcesLoaded++;
        })
    })

    const loadMapConfig = () => {
        return fetch(config.model_root + 'shared/maps/get_map_config.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
    }

    const loadMapElems = () => {
        return fetch(config.model_root + 'shared/maps/get_map.php?cid=' + cid, {
            method: "GET"
        })
            .then(response => response.json())
    }

    $ : mapOptions = {
        center: [map_config.center_lat, map_config.center_lng],
        zoom: map_config.zoom
    };
    const tileUrl = "https://api.maptiler.com/maps/basic-v2/{z}/{x}/{y}.png?key=XYDeIO73thKXzrPIFxqd";
    const tileLayerOptions = {
        minZoom: 10,
        maxZoom: 17,
        maxNativeZoom: 19,
        attribution: "\u003ca href=\"https://www.maptiler.com/copyright/\" target=\"_blank\"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href=\"https://www.openstreetmap.org/copyright\" target=\"_blank\"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e",
    };
</script>

<div class="map-container">
    <div class="map py-2">
        {#if resourcesLoaded >= 2}
            <LeafletMap options={mapOptions}>
                <TileLayer url={tileUrl} options={tileLayerOptions}/>
                {#each map_items as item}
                    <Marker latLng={[item.lat, item.lng]}>
                        <Popup>
                            <b>{item.title}</b>
                            {#if item.file_id != -3}
                                {#await service.loadFile(item.file_id)}
                                    warte..
                                {:then data}
                                    <img src="{config.application_root}files/{data.fpath}" class="point_image"/>
                                {/await}
                            {/if}
                            {#if item.description.length > 0}
                                <br/>
                                <div style="white-space: pre-line">
                                    {@html linkifyHtml(item.description)}
                                </div>
                            {/if}
                        </Popup>
                    </Marker>
                {/each}
            </LeafletMap>
        {/if}
    </div>
    <a href="https://maptiler.com/" target="_blank">
        <img src="/images/maptiler-logo.png" alt="MapTiler Logo" class="maptiler-logo">
    </a>
</div>

<style>
    .map-container {
        position: relative;
    }

    .maptiler-logo {
        position: absolute;
        bottom: 15px; /* Abstand vom unteren Rand */
        left: 4px; /* Abstand vom linken Rand */
        width: 100px; /* Größe des Logos */
        z-index: 1000; /* Sicherstellen, dass es über der Karte liegt */
    }

    .map {
        height: 500px;
        width: 100%;
    }

    .point_image {
        max-width: 160px;
        display: block;
        margin-top: 8px;
        margin-bottom: 4px;
    }

    @media screen and (max-width: 600px) {
        .map {
            height: 360px;
        }
        .maptiler-logo {
            width: 80px;
        }
    }

    :global(.leaflet-container) {
        z-index: 0;
    }
</style>
